// @flow

import React, { Component } from 'react';

import { connect } from 'react-redux';
import { seeker as fetch } from 'app/redux/modules/seekers';

import i18n from 'app/common/i18n';
import Button from 'app/common/button';
import Loading from 'app/common/Loading';
import { Grid, Cell } from 'react-flexr';

import Input from 'app/common/form/input';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOff from '@mui/icons-material/HighlightOff';
import { Avatar } from '../common/avatar/Avatar';

function fixText(name, val) {
  switch (name) {
    case 'RKI':
      return val ? 'Er i RKI' : 'Er ikke i RKI';
    case 'Smoker':
      return val ? 'Er ryger' : 'Er ikke ryger';
    case 'Pets':
      return val ? 'Har husdyr' : 'Har ikke husdyr';
    default:
      return null;
  }
}

@connect(() => ({}), { fetch })
@i18n
class ProfileDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      loading: false,
      data: null,
      reason: ''
    };
  }

  componentDidMount() {
    if (this.props.open === true && !this.state.open) {
      this.handleOpen();
    }
  }

  i18n;
  handleOpen = () => {
    this.setState({ open: true, loading: true });
    this.props
      .fetch(this.props.id)
      .then((result) => {
        this.setState({ loading: false, data: result.payload.result });
      })
      .catch((err) => {
        if (__DEV__) {
          console.error(err);
        }
        this.setState({ loading: false, data: null });
      });
  };

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    } else {
      this.setState({ open: false, loading: false, data: null });
    }
  };

  renderDialog() {
    const { fullScreen } = this.props;
    const { data, loading, open } = this.state;

    return (
      <Dialog
        fullWidth
        fullScreen={fullScreen}
        open={open}
        onClose={this.handleClose}
      >
        <DialogTitle>{this.props.i18n('Profile')}</DialogTitle>
        <DialogContent>
          {data ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <Avatar
                url={data.picture}
                email={this.props.email}
                style={{ paddingBottom: '50px' }}
              />
              <Grid>
                <Cell size="1/2" palm="1/1">
                  <Input
                    fullWidth
                    name="birthday"
                    value={data.birthday || this.props.i18n('Not specified')}
                    type="text"
                    label={this.props.i18n('Birthday')}
                  />
                </Cell>
                <Cell size="1/2" palm="1/1">
                  <Input
                    fullWidth
                    name="type"
                    value={
                      data.type
                        ? this.props.i18n(data.type)
                        : this.props.i18n('Not specified')
                    }
                    type="text"
                    label={this.props.i18n('Type')}
                  />
                </Cell>
                <Cell size="1/2" palm="1/1">
                  <Input
                    fullWidth
                    name="reason"
                    value={
                      data.reason
                        ? this.props.i18n(data.reason)
                        : this.props.i18n('Not specified')
                    }
                    type="text"
                    label={this.props.i18n('Reason')}
                  />
                </Cell>
                <Cell size="1/2" palm="1/1">
                  <Input
                    fullWidth
                    name="employment"
                    value={
                      data.employment
                        ? this.props.i18n(data.employment)
                        : this.props.i18n('Not specified')
                    }
                    type="text"
                    label={this.props.i18n('Employment')}
                  />
                </Cell>
                <Cell size="1/2" palm="1/1">
                  <Input
                    fullWidth
                    name="preferedLanguage"
                    value={
                      data.preferedLanguage
                        ? this.props.i18n(data.preferedLanguage)
                        : this.props.i18n('Not specified')
                    }
                    type="text"
                    label={this.props.i18n('Prefered language')}
                  />
                </Cell>
                <Cell size="1/2" palm="1/1">
                {[data.smoker, data.pets, data.rki]
                  .filter(Boolean)
                  .map(({ name, val }) => (
                    <div
                      key={name}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap'
                      }}
                    >
                      {val ? <CheckCircleOutlineIcon /> : <HighlightOff />}
                      &nbsp;
                      <span>{this.props.i18n(fixText(name, val))}</span>
                    </div>
                  ))}
                </Cell>
              </Grid>
            </div>
          ) : null}
          <div style={{ clear: 'both', height: '1em', display: 'block' }} />
          {loading ? <Loading /> : !data ? 'Something went wrong...' : null}
        </DialogContent>
        <DialogActions>
          <Button
            flat
            label={this.props.i18n('Close')}
            onClick={this.handleClose}
          />
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const { label, icon } = this.props;
    return this.props.open === true ? (
      this.renderDialog()
    ) : (
      <div style={{ display: 'inline-block' }}>
        <Button flat label={label} icon={icon} onClick={this.handleOpen} />
        {this.renderDialog()}
      </div>
    );
  }
}

function ProfileDialogWithMobileDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return <ProfileDialog {...props} fullScreen={fullScreen} />;
}

export default ProfileDialogWithMobileDialog;
